module.exports = __webpack_public_path__ + "img/type1_default.27ffde63.png";